(function ($) {
  'use strict'; // because lax mode is hazardous.

  /**
   * The gist of what we're going to do:
   *
   *   1. First, we're going to define a basic Javascript object that represents
   *      a cart object. For the client the product "name" is the fund receiving
   *      the donation. We're going to assume the "name" we receive is unsafe,
   *      and sanitize it during the addition process.
   *
   *   2. Next, we're going to hydrate the data structures by parsing the cart
   *      cookie. Working with cookies in JS is a mess, so see the Cookies.es5.js
   *      library for a simple wrapper around get/set/delete cookies. We're also
   *      going to encode the data into Base64 string, so that it's harder for the
   *      visitor to manipulate.
   *
   *   3. Once the data has been hydrated from storage, we're going to render a
   *      simple cart widget. We're going to add a button to remove the cart item
   *      and wire it to an event in 4.
   *
   *   4. Now we wire up event handlers for common actions: add to cart, remove
   *      from cart.
   *
   *   5. Now we add some special handling logic to generate a url in the
   *      following format, and set the "checkout" HREF to it:
   *
   *      * Base URL: https://secure.acceptiva.com/
   *      * "cst" - an unknown parameter that always has the value "108a25"
   *      * Line Items:
   *        * `shoplist_24_20_str` - the title of the "product"
   *        * `shoplist_24_20_amt` - the cost of the "product" in dollars
   *        * Subsequent products increment the 2nd number by 1. Don't expect the
   *          slots to be in consistent order.
   *
   *      Example: https://secure.acceptiva.com/?cst=108a25&shoplist_24_20_str=Adams+Family+Fund&shoplist_24_20_amt=10.00&shoplist_24_21_str=Georgia+Marie+Abdow+Fund&shoplist_24_21_amt=100.00
   *
   *  Cookie Technical Constraints:
   *
   *    * The maximum size of a cookie is 4kb or 4096 characters.
   *    * Cookies can be tampered with by savvy users when stored in plain-text.
   *    * Base64 encoding can be used to encode the value to make tampering more
   *      difficult, but increases length by 33% (reducing available length to
   *      3kb).
   *    * Base64 also includes characters not allowed in cookies, so some helpers
   *      are needed.
   */

  function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str));
  }

  function UnicodeDecodeB64(str) {
    return decodeURIComponent(atob(str));
  }

  var cart = [];

  // See #1, this defines the structure of the items with some type safety steps.
  function make_cart_item(name, amount) {
    // Using the functions String() and Number() makes sure the fields in
    // this object are guaranteed to be the related type.
    name = String(name);

    // However, the name could contain HTML characters and symbols which could
    // break the safety of the page. So we're going to rely on the browser to
    // sanitize this: https://stackoverflow.com/a/47140708/24950
    name = (new DOMParser())
      .parseFromString(name, 'text/html')
      .body.textContent || '';

    return {
      str: name,
      amt: Number(amount)
    };
  }

  // See #2, this method makes hydrating the cart simpler to abort if/when we find
  // something that doesn't belong.
  function hydrate_cart_from_cookie() {
    // Parse the encoded JSON by decoding it first. Using atob() to transform
    // the base64 encoded value into a regular string.
    var json;

    try {
      json = JSON.parse(UnicodeDecodeB64(Cookies.get('cart')));
    } catch (e) {
      console.error('Unexpected parse error. Maybe the cart is empty or no JSON is stored?', e);
      return;
    }

    // Always distrust user input! So lets make sure folks are honest, and
    // mostly harmless...
    if (!Array.isArray(json)) {
      console.error('Cart cookie contains an invalid structure, expected root value to be an array.');
      return;
    }

    // Now lets shortcut the validation process, and combine a couple of steps:
    cart = json
      // Only keep items with valid structure and typing.
      .filter(function (item) {
        return 'str' in item && typeof item.str === 'string'
          && 'amt' in item && typeof item.amt === 'number';
      })
      // Now, return a safe, sanitary copy of the item using our method.
      .map(function (item) {
        return make_cart_item(item.str, item.amt);
      });

    if (cart.length > 0) {
      // Trigger #3 because there are items in the cart.
      render_cart_widget();
    }
  }

  function write_updated_cookie() {
    // When writing cookies, it's recommended to skip the domain but to set the
    // path to "/" so that it's available site-wide. The duration may be set in
    // seconds, if the client wants the cart to linger for some time.
    if (cart.length === 0) {
      Cookies.del('cart', null, '/');
    } else {
      Cookies.set('cart', b64EncodeUnicode(JSON.stringify(cart)), null, null, '/');
    }
  }

  function render_cart_widget() {
    var product_list = $('.js-cart > tbody');
    var total = 0;

    // Remove old cart contents.
    product_list.empty();

    cart.forEach(function (item, index) {

      // Tally up the total donation
      total += item.amt;

      // Append a table row for each item in the cart
      product_list.append('<tr><th>' + item.str + '</th><td class="text-right">$' + item.amt.toFixed(2) + '<a href="#" class="js-remove-item ml-3 text-decoration-none" data-index="' + index + '"><span class="icon icon-delete text-small"></span></a></td></tr>');
    });

    // Toggle the saved donations table and complete donation tab
    if (cart.length > 0) {
      $('.js-cart-total').text('$' + total.toFixed(2));
      $('.js-cart-title').show();
      $('.js-cart-container').show();
      $('.js-view-cart').show();
    } else {
      $('.js-cart-title').hide();
      $('.js-cart-container').hide();
      $('.js-view-cart').hide();
    }

    // Update the checkout link and stored cookie any time the cart is rendered.
    // It is safe to assume that any time the cart changed and needs to render,
    // the checkout link and cookie should change too.
    update_checkout_link();
    write_updated_cookie();
  }

  // step #5 executes as needed, updating the checkout link.
  function update_checkout_link() {
    var checkout_buttons = $('.js-checkout');

    var url = 'https://secure.acceptiva.com/?cst=108a25';

    // Now we need to add all our cart items to the URL.
    cart.forEach(function (item, index) {
      // Write the item title
      url += '&shoplist_24_' + (20 + index) + '_str=' + encodeURIComponent(item.str);
      // Write the item price
      url += '&shoplist_24_' + (20 + index) + '_amt=' + item.amt.toFixed(2);
    });

    checkout_buttons.attr('href', url);
  }

  // run step #2,
  if (Cookies.get('cart')) {
    hydrate_cart_from_cookie();
  }

  // Step #4, register add/remove handlers

  $('.js-cart').on('click', '.js-remove-item', function (e) {
    e.preventDefault();

    // Delete this item from the cart.
    cart.splice($(this).data('index'), 1);

    // Close complete donation modal
    if (in_complete_donation_modal($(this)) && cart.length === 0)
      $(this).closest('.modal').find('.close').click();

    // Indices have shifted due to the deletion. This is solved 1 of two ways:
    //
    //  * Iterate the rows and reduce index values by 1 for anything greater
    //    than the deleted index.
    //  * Or, re-render the template. (We're being lazy, so we're doing this.)
    render_cart_widget();
  });

  var reviewDonation = false;

  $('.js-add-to-cart').on('click', function (e) {
    e.preventDefault();

    var form = $(this).closest('form');
    var name = form.find('.js-product-name').val();
    var amount = form.find('.js-product-amount').val();

    if (!is_valid_donation(amount)) return;

    cart.push(make_cart_item(name, amount));


    if ($('body').hasClass('post-type-archive-funds')
      || $('body').hasClass('search-results')) {
      reviewDonation = true;
      $(this).closest('.modal').modal('hide');
    } else {
      $('#complete-donation').modal('show');
    }

    render_cart_widget();
  });

  $('.modal').on('hidden.bs.modal', function (event) {
    if (reviewDonation) {
      $('#complete-donation').modal('show');
      reviewDonation = false;
    }
  });


  $('.js-checkout').on('click', function (e) {
    e.preventDefault();

    // Send to 3rd party
    window.open($(this).attr('href'));

    // Clean up
    cart = [];

    $(this).closest('.modal').modal('hide');

    render_cart_widget();
  });

  $('.js-empty-cart').on('click', function (e) {
    e.preventDefault();

    if (cart.length === 1 || confirm('Do you want to clear all saved donations?')) {
      cart = [];

      if (in_complete_donation_modal($(this)))
        $(this).closest('.modal').find('.close').click();

      render_cart_widget();
    }
  });

  if (!$('body').hasClass('post-type-archive-funds')
    || $('body').hasClass('search-results')
    || $('body').hasClass('paged')) {
    $('.js-add-more')
      .removeAttr('data-dismiss')
      .attr('href', '/funds');
  }

  function is_valid_donation(amount) {

    // Only allow numbers, $5 or more
    if (+amount === 0 || isNaN(+amount)) {
      alert('An amount is required.');
      return false;
    }

    if (+amount < 5) {
      alert('We\'re sorry - We can only accept credit card donations of $5 or more.');
      return false;
    }

    // Enforce count limit
    if (cart.length === 6) {
      alert('You have reached the limit of 6 saved donations.');
      return false;
    }

    return true;
  }

  function in_complete_donation_modal(button) {
    return button.closest('#complete-donation').length;
  }

}(jQuery));